import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Modal, Button, Dropdown, Table, Icon} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

const {updateWarrantyStatus} = Actions;

const UpdatedWarranties = ({list}) => {
  return (
    <Table striped className='update-warranty-status'>
      <Table.Header>
        <Table.Row textAlign='center'>
          <Table.HeaderCell>
            NÚMERO GARANTÍA
          </Table.HeaderCell>
          <Table.HeaderCell>
            DEALER
          </Table.HeaderCell>
          <Table.HeaderCell>
            VEHÍCULO
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {list.map((warranty, idx) => {
          return (
            <Table.Row key={idx} textAlign='center'>
              <Table.Cell>{warranty.code}</Table.Cell>
              <Table.Cell>{warranty.dealer}</Table.Cell>
              <Table.Cell>{warranty.chassis}</Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

const StatusModal = ({
  initDate,
  endDate,
  typeTwc,
  dealer,
  status,
  processedWarrantyList,
  isWarrantySelected,
  warrantyStatus,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [newStatus, setNewStatus] = useState(null);
  const [updateWarranties, setUpdateWarranties] = useState([]);
  const dispatch = useDispatch();

  const getStatusOptions = () => {
    return warrantyStatus.filter(
      (warranty) => !['TODOS', status].includes(warranty.value)
    );
  };

  const closeModal = () => {
    setNewStatus(null);
    setModalIsOpen(false);
    setConfirmModal(false);
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const onSaveChanges = () => {
    const params = {
      initDate,
      endDate,
      typeTwc,
      dealer,
      'currentStatus': status,
      'detail': updateWarranties,
      'status': newStatus,
    };
    dispatch(updateWarrantyStatus(params));
    closeModal();
  };

  const changeStatus = (e, {value}) => {
    const updateList = processedWarrantyList
      .filter((item) => item.checked)
      .map((item) => ({...item, 'status': value}));

    setUpdateWarranties(updateList);
    setNewStatus(value);
  };

  return (
    <Modal
      onOpen={openModal}
      open={modalIsOpen}
      className="status-modal"
      trigger={
        <Button primary disabled={!isWarrantySelected}>
          Cambio de Estado
        </Button>
      }
    >
      <Modal.Header>Cambio de Estado de garantías</Modal.Header>
      <Modal.Content className="status-content">
        <h4>Seleccione el estado a cambiar de las garantías seleccionadas:</h4>
        <Dropdown
          selection
          options={getStatusOptions()}
          value={newStatus}
          onChange={changeStatus}
          placeholder="Seleccione el estado"
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={closeModal}>Cerrar</Button>
        <Button
          primary
          disabled={!newStatus}
          onClick={() => setConfirmModal(true)}
        >
          Proceder
          <Icon name="angle right" size="large"></Icon>
        </Button>
      </Modal.Actions>
      <Modal
        onClose={() => setConfirmModal(false)}
        open={confirmModal}
        className="confirmation-status"
        size="small"
      >
        <Modal.Header>
          ¿Esta seguro de cambiar de estado las siguientes garantías?
        </Modal.Header>
        <Modal.Content>
          <UpdatedWarranties list={updateWarranties} />
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setConfirmModal(false)}>Cancelar</Button>
          <Button
            positive
            icon="check"
            content="Guardar"
            onClick={onSaveChanges}
          />
        </Modal.Actions>
      </Modal>
    </Modal>
  );
};

export default StatusModal;
